<template>
  <div class="container">
    <div class="row">
      <div class="col-12 text-center">
        <div class="alert alert-danger">
           Your are not authorized to access to this ressource !
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import { defineComponent } from 'vue';
export default defineComponent({
  name: 'unauthorizeAcces',
});
</script>
